import TitlePatternUtility from './TitlePatternUtility.coffee'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isBetween from 'dayjs/plugin/isBetween'
import minMax from 'dayjs/plugin/minMax'
import utc from 'dayjs/plugin/utc'
dayjs.extend(relativeTime)
dayjs.extend(localizedFormat)
dayjs.extend(isSameOrBefore)
dayjs.extend(isBetween)
dayjs.extend(minMax)
dayjs.extend(utc)

marketplace = {}
setMarketplace = (mkt = {}) ->
  marketplace = mkt

humanize = (value) -> "#{value}".replace(/_/g, ' ').trim()

capitalize = (value) ->
  v = humanize value
  v.charAt(0).toUpperCase() + v.slice(1)

titleize = (value) ->
  v = humanize value
  words = v.split(' ')
  tokens = []
  for w in words
    if skipCapitalize(w)
      tokens.push w
      continue

    if shouldUppercaseWholeWord(w)
      tokens.push w.toUpperCase()
      continue

    tokens.push capitalize(w)

  tokens.join ' '

skipCapitalize = (word) ->
  word.toLowerCase().trim() in ['mi.']

shouldUppercaseWholeWord = (word) ->
  word.toLowerCase().trim() in ['cpg']

numberize = (value) ->
  return (0).toLocaleString() if !value
  num = value
  num = parseInt("#{value}") unless isFloat(value)
  num = 0 if isNaN num
  num.toLocaleString()

numberizeShort = (value) ->
  v = parseFloat value

  num = Math.round(v / 100) * 100 if v >= 1000
  num = Math.round(v / 100000) * 100000 if v >= 1000000
  if v >= 1000000
    num = num / 1000000
    postfix = 'M'
  else if v >= 1000
    num = num / 1000
    postfix = 'K'
  else
    num = v
    postfix = ''

  "#{num}#{postfix}"

offerState = (value) ->
  x = "#{value}".replace(/_/g, ' ').toLowerCase()
  x = 'denied' if x is 'ignored'
  x = 'pending' if x is 'draft'
  x = 'pending' if x is 'submitted'
  x

mapLookup = (key, map = {}) ->
  if Array.isArray(key)
    return key.map((t) -> (map[t] || titleize(t)))
  else
    return (map[key] || titleize(key))

isInt = (n)-> Number(n) is n && n % 1 is 0
isFloat = (n)-> Number(n) is n && n % 1 isnt 0

dateWindowFor = (startDay, endDay) ->
  format = 'MMM DD'
  longFormat = "MMM DD, YYYY"
  localStartDay = dayjs("#{startDay}".substr(0, 10))
  localEndDay = dayjs("#{endDay}".substr(0, 10))

  sameDate = dayjs(startDay).isSame(dayjs(endDay), 'day')
  sameDay = localStartDay.$D is localEndDay.$D
  sameMonth = localStartDay.$M is localEndDay.$M
  sameYear = localStartDay.$y is localEndDay.$y
  
  if sameDate
    return localStartDay.format(longFormat)

  if sameYear and sameMonth and not sameDay
    return "#{localStartDay.format(format)} - #{localEndDay.format('DD, YYYY')}"

  if sameYear and not sameMonth
    return "#{localStartDay.format(format)} - #{localEndDay.format(longFormat)}"

  "#{localStartDay.format(longFormat)} - #{localEndDay.format(longFormat)}"

removeSecondsFromTime = (time) ->
  [time, type] = time.split(' ')
  "#{time.slice(0, 5)} #{type}"

timeWindowFor = (startTime, endTime) ->
  "#{removeSecondsFromTime(startTime)} - #{removeSecondsFromTime(endTime)}"

omnichannelTypes = ->
  signage: 'Physical Signs'
  sheet: '8.5" x 11" Sign'
  popup_banner: 'Pullup Banner'
  digital: 'Digital Broadcasts'
  email: 'Email'
  sms: 'SMS'
  push: 'Push Notification'
  social: 'Social Posts'
  instagram: 'Instagram'
  tiktok: 'TikTok'
  twitter: 'X (Twitter)'
  facebook: 'Facebook'

titleizeOmnichannelType = (type) ->
  omnichannelTypes()[type]

isAddonOmnichannel = (pricingModel) ->
  !!omnichannelTypes()[pricingModel.replace('addon_', '')]

export default
  initializeMarketplace: (marketplace) ->
    setMarketplace(marketplace)

  formatSpaceType: (value) ->
    v = "#{value}"
    tokenized = v.split('_')
    return "Item Distribution / Sampling" if v is 'product_sampling'

    if v.includes('booth_')
      return "On-Site Activation / #{tokenized[1]} Space"

    return "Native Integration" if v is 'native_integration'
    return "Social Media Post" if v is 'social_media_post'
    return "Social & Digital" if v is 'omnichannel'
    return "#{capitalize(tokenized[0])} #{capitalize(tokenized[1])}" if v.includes('_')
    return capitalize(v)
  formatShortSpaceType: (value) ->
    v = "#{value}"
    tokenized = v.split('_')
    return "Sampling" if v is 'product_sampling'
    return "#{tokenized[1]} Space" if v.includes('booth_')
    return "Native Integration" if v is 'native_integration'
    return "Social Media Post" if v is 'social_media_post'
    return "Other CPG" if v is 'other_cpg_distribution'
    return "Social & Digital" if v is 'omnichannel'
    return "#{capitalize(tokenized[0])} #{capitalize(tokenized[1])}" if v.includes('_')
    return capitalize(v)
  formatBoothSize: (value) -> "#{value}".split('_')[1]
  formatSpaceTypeForQuantity: (value, quantity) ->
    v = "#{value}"
    tokenized = v.split('_')
    format = "#{tokenized[1]} Booth" if v.includes('booth_')
    format = 'Recess Sampling' if value is 'product_sampling'
    format ||= "#{capitalize(tokenized[0])} #{capitalize(tokenized[1])}" if v.includes('_')
    format = "#{numberize(quantity)} #{capitalize(format)}"
    format = "#{format}s" if quantity isnt 1
    format
  formatShortSpaceTypeForQuantity: (value, quantity) ->
    v = "#{value}"
    tokenized = v.split('_')
    format = "#{tokenized[1]} Booth" if v.includes('booth_')
    format = 'Sample' if value is 'product_sampling'
    format ||= "#{capitalize(tokenized[0])} #{capitalize(tokenized[1])}" if v.includes('_')
    format = "#{numberize(quantity)} #{capitalize(format)}"
    format = "#{format}s" if quantity isnt 1
    format
  formatEventType: (type) -> # deprecated
    map = marketplace?.listing.types
    mapLookup(type, map)

  formatListingType: (type) ->
    map = marketplace?.listing?.types
    mapLookup(type, map)

  formatListingClass: (klass) ->
    map = marketplace?.listing?.classes
    mapLookup(klass, map)

  formatListingCategory: (category) ->
    map = marketplace?.listing?.categories
    mapLookup(category, map)

  formatListingAudience: (audience) ->
    map = marketplace?.listing?.audiences
    mapLookup(audience, map)

  formatPersonaSegment: (personaSegment) ->
    map = marketplace?.listing?.unacast_persona_segments
    mapLookup(personaSegment, map)

  formatPersonaScore: (score) ->
    Math.round score

  formatOmnichannelType: (type) ->
    titleizeOmnichannelType(type) || titleize(type)

  formatListingTitle: (listing) ->
    TitlePatternUtility.formatListingTitle listing

  formatAvailabilityTitle: (availability) ->
    TitlePatternUtility.formatAvailabilityTitle availability

  formatLineItemName: (lineItem) ->
    return titleizeOmnichannelType(lineItem.pricing_model.replace('addon_', '')) if isAddonOmnichannel(lineItem.pricing_model)
    name = lineItem.pricing_model or lineItem.space_name or lineItem.description
    name = name.replace(/addon|distribution/g, '')
    name = humanize(name)
    name = titleize(name)
    name

  formatCapitalized: (value) ->
    return '' if (!value)
    return capitalize(value) if !Array.isArray(value)
    list = ("#{v}".replace(/_/g, ' ') for v in value)
    list = (capitalize(v) for v in list)

  formatOfferState: (value) ->
    return '' if (!value)
    return offerState(value) if !Array.isArray(value)
    list = (offerState(v) for value in list)

  formatNumber: (value) ->
    numberize(value)

  formatNumberShort: (value) ->
    numberizeShort(value)

  formatList: (list, character = ',', empty = 'None') ->
    return empty unless list?.length
    return list unless Array.isArray(list)
    separator = "#{character} "
    separator = " #{separator}" unless ',' is character
    list.join separator
  formatTitle: (value) ->
    return '' if (!value)
    return titleize(value) if !Array.isArray(value)
    list = ("#{v}".replace(/_/g, ' ') for v in value)
    list = (titleize(v) for v in list)
    list.join(' ')

  formatAddonName: (value) ->
    return '' if not value
    value.replace 'addon', 'add-on'

  formatDateWindow: (startDay, endDay) ->
    dateWindowFor startDay, endDay

  formatTimeWindow: (startTime, endTime) ->
    timeWindowFor startTime, endTime

  formatLocation: (location = {}) ->
    venueClass = location.venue_class
    venueClass ||= 'venue'
    return titleize venueClass if venueClass isnt 'venue'
    city = location.venue_city || location.city
    state = location.venue_state || location.state
    address = [city, state].filter((v) => v)
    address.join ', '

  formatAddress: (value) ->
    return '' if (!value)
    value = value
      .replace(/United States|US/g, '')
      .replace(', ,', ', ')
      .replace('  ', ' ')
      .replace(/,/g, ', ')

    words = value.split(' ').map((word) -> word.trim())
    words.map((word) ->
      return word if word.replace(',', '').length is 2
      titleize(word.toLowerCase())
    ).join(' ').trim().replace(/,$/, '')

  formatHandoutSlim: (value) ->
    return '' unless value
    value
      .replace(/Organizer hands out|Organizer delivers/, '')
      .replace('to each', '/')
      .replace('.', '')
      .trim()

  formatDeliveryPointName: (name, deliveryPoints) ->
    return name if deliveryPoints is 1
    n = 'people' if name is 'person'
    n ||= "#{name}s"
    n

  formatDMA: (value) ->
    tokens = titleize(value.replace(/_|-/g, ' ').toLowerCase()).split(' ')
    tokens = for t in tokens
      pTokens = t.split('(')
      t = "(#{titleize(pTokens[1])}" if pTokens.length > 1
      t = t.toUpperCase() if t.length is 2
      t
    tokens.join(' ')

  formatOnOff: (value) -> if value then 'On' else 'Off'
  formatYesNo: (value) -> if value then 'Yes' else 'No'
  formatYesNoInverse: (value) ->
    return 'No' if value is 'yes' || value is true
    return 'Yes' if value is 'no' || value is false
  formatYesNoNotSure: (value) ->
    return 'Not answered' unless value?
    return 'No' if "#{value}".toLowerCase() is 'no' || value is false
    return 'Yes' if "#{value}".toLowerCase() is 'yes' || value is true
    return 'Not sure'
  formatYesNoNotSureInverse: (value) ->
    return 'Not sure' unless value?
    return 'No' if value is 'yes' || value is true
    return 'Yes' if value is 'no' || value is false
    return 'Not sure'
  formatHuman: (value) -> humanize(value)
  formatDate: (date, format) ->
    if !date
      return ''

    return dayjs(date).format(format || 'MM/DD/YYYY')

  formatDateLong: (date) ->
    return '' unless date
    dayjs(date).format('llll')

  formatTime: (time, format) ->
    return 'Noon' if time is '12:00 PM'
    return 'Midnight' if time is '11:59 PM'
    return time

  fromNow: (value) ->
    dayjs(value).fromNow()

  formatMoney: (value, options={}) ->
    hideCents = false is options.cents
    d = 2
    d = 0 if hideCents

    amount = value
    amount = parseFloat("#{amount}")
    return '' if isNaN amount
    amount = Math.round(amount) if hideCents

    amount.toFixed(d)
      .replace(/\./g, '.')
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  formatMoneyShort: (value) ->
    amount = value
    amount = parseFloat("#{amount}")
    return '' if isNaN amount
    numberizeShort(amount)

  formatDollarSign: (value) ->
    amount = parseFloat(value)
    return '-' if amount is 0
    "$#{value}"

  formatDollarSignShort: (value) -> 
    amount = value
    amount = parseFloat("#{amount}")
    return '' if isNaN amount
    "$#{numberizeShort(amount)}"

  formatSpaceQuantityRange: (event, space) ->
    minQuantity = event.reach if 'video_wall' is space.type
    minQuantity||= space.min_quantity
    minQuantity||= 1
    minQuantity = parseInt(minQuantity)
    maxQuantity = parseInt(space.max_quantity) || 0

    formattedMin = numberizeShort(minQuantity)
    return formattedMin if (space.type isnt 'product_sampling') || (0 is maxQuantity) || (minQuantity is maxQuantity)

    formattedMax = numberizeShort(maxQuantity)
    "#{formattedMin} - #{formattedMax}"

  formatOrdinal: (number) ->
    n = parseInt(number)
    switch n
      when 1 then '1st'
      when 2 then '2nd'
      when 3 then '3rd'
      else "#{n}th"

  formatOrganizationName: (topOrg, subOrganizations) ->
    if (Array.isArray(topOrg))
      subOrganizations = topOrg
      topOrg = null

    subOrgs = subOrganizations
    subOrgs = [subOrganizations] if subOrganizations and !Array.isArray(subOrganizations)

    top_org = topOrg.name if topOrg?.name?
    top_org += ' - ' if subOrgs?.length

    subOrgsList = subOrgs.map((org) -> org.name).join(' | ') if subOrgs?.length
    subOrgsList = '' if !subOrgsList

    if topOrg.id == subOrganizations.id
      return "#{subOrgsList}"

    "#{top_org} #{subOrgsList}"

  eventDays: (event) ->
    return '' if !event?.local_start_day
    year = dayjs(event.local_start_day).format('YYYY')

    if event.local_start_day[0..10] is event.local_end_day[0..10]
      time = dayjs(event.local_start_day).format('MM/DD')
    else
      startMonth = dayjs(event.local_start_day).format('MM')
      endMonth = dayjs(event.local_end_day).format('MM')
      if startMonth is endMonth
        time = "#{dayjs(event.local_start_day).format('MM/DD')} - #{dayjs(event.local_end_day).format('DD')}"
      else
        time = "#{dayjs(event.local_start_day).format('MM/DD')} - #{dayjs(event.local_end_day).format('MM/DD')}"
    
    time = "#{year} #{time}"
    time

  eventDayTimes: (event) ->
    return '' if !event?.local_start_day
    if event.local_start_day is event.local_end_day
      time = "#{dayjs(event.local_start_day).format('MM/DD/YYYY')} #{event.local_start_time}"
      time += " - #{event.local_end_time}" if event.local_end_time
    else
      time = "#{dayjs(event.local_start_day).format('MM/DD/YYYY')} #{event.local_start_time}"
      time += " - #{dayjs(event.local_end_day).format('MM/DD/YYYY')} #{event.local_end_time}" if event.local_end_day
    time

  formatMaxLength: (str, maxLength) ->
    if str.length > maxLength
      return str.slice(0, maxLength - 3) + "..."
    return str

  formatUniversity: (value) ->
    value = value.replace(/(The University)|(University)/gi, 'U')
    value = value.replace(/(The College)|(College)/gi, 'Clg')
    value = value.replace(/(The School)|(School)/gi, 'Sch')
    value = value.replace(/(Eastern)|(East)/gi, 'E')
    value = value.replace(/(Western)|(West)/gi, 'W')
    value = value.replace(/(Northern)|(North)/gi, 'N')
    value = value.replace(/(Southern)|(South)/gi, 'S')
    value

  formatKeyValue: (key) ->
    words = key.split('_')
    value = (capitalize(w) for w in words)
    value.join ' '

  formatPlatform: (website) ->
    switch "#{website}".replace(/_/g, '').toLowerCase()
      when 'youtube' then 'YouTube'
      else titleize(website)

  formatTextArea: (value='') ->
    regexUrl = /((http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/[^\s]*)?[^,.])/gi
    v = value
    v = '' unless value
    v = v.replaceAll regexUrl, '<a href="//$1" target="_blank" class="text-recess">$1</a>'
    v = v.replaceAll '//http', 'http'
    v = v.replaceAll /\n/g, '<br/>'
    v

  formatDomain: (value) ->
    return '' unless value
    v = value.replace(/https?:\/\//i, '')
    try
      new URL("https://#{v}").hostname.replace('www.', '');
    catch
      v

  formatBrandCategory: (value) ->
    category = marketplace?.brand?.categories[value]
    category ||= titleize value
    category

  formatAvailabilityLocation: (audienceAvailability, venue) ->
    { title: availabilityTitle } = audienceAvailability
    { name: venueName, address: { city, state } } = venue
    "#{availabilityTitle} @ #{venueName} #{city}, #{state}"

  formatVenueLocation: (venue) ->
    { name, address: { city, state } } = venue
    "#{name} #{city}, #{state}"
